import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=45816b6c&scoped=true"
import script from "./SelectGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectGroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=45816b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45816b6c",
  null
  
)

export default component.exports